export class LoginResult {
    public Success: boolean;
    public Message: string;
}


// WEBPACK FOOTER //
// ./src/entities/loginResult.ts